import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
const languages = [
    { label: "Albanian", code: "sq" },
    { label: "Romanian", code: "ro" },
    { label: "Polish", code: "pl" },
    { label: "French", code: "fr" },
    { label: "Italian", code: "it" },
    { label: "Swedish", code: "sv" },
    { label: "Portuguese", code: "pt" },
    { label: "Norwegian", code: "no" },
    { label: "English", code: "en" },
    { label: "Dutch", code: "nl" },
];

const supportedLanguageCodes = languages.map(lang => lang.code);

const resources = supportedLanguageCodes.reduce((acc, code) => {
    try {
        acc[code] = {
            translations: require(`./locales/${code}/translations.json`)
        };
    } catch (error) {
        console.warn(`Translation file for ${code} not found.`);
    }
    return acc;
}, {});

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        supportedLngs: supportedLanguageCodes,
        ns: ['translations'],
        defaultNS: 'translations',
        detection: {
            order: ['localStorage', 'querystring', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng',
        },
        interpolation: {
            escapeValue: false,
        },
    });

i18n.languages = supportedLanguageCodes;

export default i18n;